import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import apiKey from "../../../config/apiKey";
import axios from "axios";
import { toast } from "react-toastify";

const OnlineTutionn = () => {
  const { t } = useTranslation();
  const student = JSON.parse(localStorage.getItem("edo-student"));
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [formData, setFormData] = useState({
    class_id: "",
    subject_id: "",
    type_id: "2", // online
  });

  // Fetch classes + subject list for selected class
  useEffect(() => {
    axios
      .get(`${apiKey}/api/edolutions/student/classes`, {
        headers: { Authorization: `Bearer ${student?.token}` },
      })
      .then((res) => setClasses(res.data || []))
      .catch(console.error);
  }, [student?.token]);

  useEffect(() => {
    if (!formData.class_id) {
      setSubjects([]);
      return;
    }
    axios
      .get(`${apiKey}/api/edolutions/student/classes/${formData.class_id}`, {
        headers: { Authorization: `Bearer ${student?.token}` },
      })
      .then((res) => setSubjects(res.data || []))
      .catch(console.error);
  }, [formData.class_id, student?.token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if class changes, reset subject
    if (name === "class_id") {
      setFormData((prev) => ({ ...prev, class_id: value, subject_id: "" }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.class_id || !formData.subject_id) {
      toast.error(t("studentDash.onlineTutionn.selectBoth"), {
        theme: "colored",
      });
      return;
    }

    setIsLoading(true);
    axios
      .post(`${apiKey}/api/edolutions/student/collect-data`, formData, {
        headers: { Authorization: `Bearer ${student?.token}` },
      })
      .then((res) => {
        toast.success(res.data.message || t("studentDash.onlineTutionn.saved"), {
          position: "bottom-right",
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });
        navigate("../online-mentor-list");
      })
      .catch(() => {
        toast.error(t("studentDash.onlineTutionn.errorOccurred"), {
          position: "bottom-right",
          theme: "colored",
        });
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="w-full">
      {/* Themed gradient header */}
      <div className="relative overflow-hidden rounded-3xl ">
 

        <div className="relative z-10 flex items-center justify-between p-4 sm:p-6">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 rounded-xl  px-3 py-2 text-white text-sm font-medium bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] active:scale-95 transition"
          >
            <BiArrowBack className="h-5 w-5" />
            {t("studentDash.common.back")}
          </button>

          <div className="text-right text-white">
            <p className="text-base sm:text-lg font-semibold">{t("studentDash.onlineTutionn.findTeacher")}</p>
            <p className="text-xs sm:text-sm opacity-90">{t("studentDash.onlineTutionn.onlineTutoring")}</p>
          </div>
        </div>
      </div>

      {/* Form card */}
      <div className="mx-auto max-w-2xl">
        <div className="mt-6 rounded-3xl border border-gray-100 bg-white/80 backdrop-blur p-4 sm:p-6 shadow-sm">
          <h2 className="text-lg sm:text-xl font-bold text-[#2A3A54]">
            {t("studentDash.onlineTutionn.tellUsWhatYoureLookingFor")}
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            {t("studentDash.onlineTutionn.chooseProfessionSpecialization")}
          </p>

          <form onSubmit={handleSubmit} className="mt-5 space-y-4">
            {/* Class */}
            <div>
              <label className="mb-1 block text-sm font-semibold text-gray-700">
                {t("studentDash.onlineTutionn.profession")}
              </label>
              <div className="relative">
                <select
                  name="class_id"
                  value={formData.class_id}
                  onChange={handleChange}
                  className="w-full appearance-none rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#2A3A54] focus:ring-2 focus:ring-[#EE5F2B]/30"
                >
                  <option value="" disabled>
                    {t("studentDash.onlineTutionn.selectProfession")}
                  </option>
                  {classes.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.class_name}
                    </option>
                  ))}
                </select>
                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                  ▾
                </span>
              </div>
            </div>

            {/* Subject */}
            <div>
              <label className="mb-1 block text-sm font-semibold text-gray-700">
                {t("studentDash.onlineTutionn.specialization")}
              </label>
              <div className="relative">
                <select
                  name="subject_id"
                  value={formData.subject_id}
                  onChange={handleChange}
                  disabled={!formData.class_id}
                  className="w-full appearance-none rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-800 outline-none transition disabled:bg-gray-50 disabled:text-gray-400 focus:border-[#2A3A54] focus:ring-2 focus:ring-[#EE5F2B]/30"
                >
                  <option value="" disabled>
                    {formData.class_id ? t("studentDash.onlineTutionn.selectSpecialization") : t("studentDash.onlineTutionn.selectProfessionFirst")}
                  </option>
                  {subjects.map((s, i) => (
                    <option key={`${s.subject_id}-${i}`} value={s.subject_id}>
                      {s.subject_name}
                    </option>
                  ))}
                </select>
                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                  ▾
                </span>
              </div>
            </div>

            {/* CTA */}
            <div className="pt-2">
              <button
                type="submit"
                disabled={isLoading}
                className={`inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] px-5 py-2.5 text-white text-sm font-semibold shadow transition active:scale-95 ${
                  isLoading
                    ? "opacity-70 cursor-not-allowed"
                    : "hover:brightness-110"
                }`}
              >
                {isLoading ? (
                  <svg
                    className="h-5 w-5 animate-spin"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0a12 12 0 00-12 12h4z"
                    />
                  </svg>
                ) : (
                  t("studentDash.onlineTutionn.findMentors")
                )}
              </button>
            </div>
          </form>
        </div>

        {/* Tip card (optional, subtle) */}
        <div className="mt-4 rounded-2xl border border-gray-100 bg-white p-4 text-sm text-gray-600">
          {t("studentDash.onlineTutionn.tip")}
        </div>
      </div>
    </div>
  );
};

export default OnlineTutionn;
